import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MenuItemsComponent } from './menu-items.component';

const routes: Routes = [
  { 
   path: '',
    children: [
      {
        path: 'default',
        component: MenuItemsComponent,
        data: {
          title: "Menu Item",
          breadcrumb: "Menu Item"
        }
      }
    ],
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MenuItemsRoutingModule { }
